import { render } from "./GuideArticleCard.vue?vue&type=template&id=5d52c823&scoped=true"
import script from "./GuideArticleCard.vue?vue&type=script&lang=js"
export * from "./GuideArticleCard.vue?vue&type=script&lang=js"

import "./GuideArticleCard.vue?vue&type=style&index=0&id=5d52c823&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d52c823"]])

export default __exports__